export const FILTER_LABEL_CLASS = 'block text-sm font-medium text-gray-700 mb-1.5';

export const FILTER_INPUT_CLASS =
  'w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-theme-500 focus:border-theme-500';

export interface IFilterSelectOption {
  value: string;
  label: string;
}

export interface IFilterSelectProps {
  id: string;
  label: string;
  value: string;
  options: readonly IFilterSelectOption[];
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

const FilterSelect = ({
  id,
  label,
  value,
  options,
  onChange,
  disabled = false,
  className,
}: IFilterSelectProps) => (
  <div className={className}>
    <label htmlFor={id} className={FILTER_LABEL_CLASS}>
      {label}
    </label>
    <select
      id={id}
      className={FILTER_INPUT_CLASS}
      value={value}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value)}
    >
      {options.map((option) => (
        <option key={option.value || `${id}-all`} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
);

export default FilterSelect;
